// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head__2w4n3","head_crumbs":"index_head_crumbs__3Ivxb","head_line":"index_head_line__Ipo7R","content":"index_content__3LQw3"};